

























































import Vue from "vue";
import * as types from "../../store/types";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "NpApplicationStep1",

  props: {},

  data: () => {
    const checks = [
      {
        question:
          "The organization is located in Greene County, Missouri or provide services for Greene County residents. (If organization’s primary office is located outside of Greene County, grant dollars may only be requested for work completed in Greene County for Greene County residents.)",
        shouldBeChecked: true,
        requirement:
          "The organization must be located in Greene County, Missouri or provide services for Greene County residents.",
      },
      {
        question:
          "The organization has existed in Greene County, Missouri as of March 3rd, 2021.",
        shouldBeChecked: true,
        requirement:
          "The organization must have existed in Greene County, Missouri as of March 3rd, 2021.",
      },
      {
        question:
          "The organization has maintained without revocation nonprofit status with a ruling date at or before March 3, 2021.",
        shouldBeChecked: true,
        requirement:
          "The organization must have maintained without revocation nonprofit status with a ruling date at or before March 3, 2021.",
      },
      {
        question:
          "The organization can demonstrate the existence of negative impacts incurred as a result of the COVID-19 public health emergency since March 3rd, 2021.",
        shouldBeChecked: true,
        requirement:
          "The organization must demonstrate the existence of negative impacts incurred as a result of the COVID-19 public health emergency since March 3rd, 2021.",
      },
    ];
    return {
      showIneligibleDialog: false,
      checks,
      checkValues: checks.map(() => false),
    };
  },

  methods: {
    ...mapActions({
      saveStep: types.SAVE_FORM_STEP,
    }),
    saveAndContinue() {
      const checkedAll = this.checkValues.every((checked) => checked);
      this.$emit("update-validity", 0, checkedAll);
      if (checkedAll) {
        // we're valid, call save then continue on
        this.saveStep({
          newCurStepNum: 1, // next step
          formFields: {
            eligible: true,
          },
        });
        this.$emit("next-step");
      } else {
        this.showIneligibleDialog = true;
      }
    },
  },

  computed: {
    ...mapGetters({
      allFormValues: types.FORM_VALUES,
      saving: types.SAVING_FORM,
    }),
    disqualifyingReasons(): string[] {
      return this.checks
        .filter((check, i) => check.shouldBeChecked != this.checkValues[i])
        .map((check) => check.requirement);
    },
  },

  watch: {
    allFormValues: {
      immediate: true,
      handler() {
        this.$emit("update-validity", 0, this.allFormValues.eligible);
        if (this.allFormValues.eligible)
          this.checkValues = this.checks.map(() => true);
      },
    },
  },
});
